import { render, staticRenderFns } from "./TaskDetailsDialog.vue?vue&type=template&id=b37f94ba&scoped=true"
import script from "./TaskDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TaskDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37f94ba",
  null
  
)

export default component.exports